<template>
  <div>
 
   
    <table style="width:100%">
      <tr>
        <td>     <div style="float：left；width:200px"> <h1>{{ translateWords.AreaManage }}</h1></div>
        </td>
 
      </tr>
      <tr>
        <td >
          {{ translateWords.RegionName }}： </td><td style="float:left"><el-input
            style="width: 300px"
            v-model="RegionQuery.RegionName"
            :placeholder="translateWords.RegionName"
          ></el-input>
        </td>
        <td>
          {{ translateWords.Status }}：</td><td style="float:left"><el-select
            v-model="RegionQuery.Status"
            :placeholder="translateWords.Status"
          >
            <el-option
              v-for="item in RegionStatusDropList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option
          ></el-select>
        </td>
        <td>
          {{ translateWords.Country }}：</td><td style="float:left"><el-select
            v-model="RegionQuery.DepartMentID"
            :placeholder="translateWords.Country"
          >
            <el-option
              v-for="item in RegionCountryDropList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option
          ></el-select>
        </td>
        <td>
          <el-button type="primary" @click="query" v-if="PermissonList.Search.value">{{
            translateWords.query
          }}</el-button>
        </td>
         <td>
          <el-button type="primary" @click="add" v-if="PermissonList.Add.value">{{
            translateWords.add
          }}</el-button>
        </td>
      </tr>
    </table> 


    <el-table :data="tableData" style="width:90%">
      <el-table-column prop="Id" :label="translateWords.Code"  width=100>
      </el-table-column>

      <el-table-column
        prop="RegionName"
        :label="translateWords.RegionName"
      >
      </el-table-column>
      <el-table-column   prop="Status" :label="translateWords.Status">
      </el-table-column>
      <el-table-column
        prop="CountryName"
        :label="translateWords.Country"
      >
      </el-table-column>
         <el-table-column 
        prop="IsUseKey" 
        v-if="false"
        :label="translateWords.IsUseKey"
      >
      </el-table-column>
        <el-table-column 
        prop="IsUseKeyStr" 
        :label="translateWords.IsUseKey"
      >
       </el-table-column>
      
        <el-table-column 
        prop="KeyCount" 
        :label="translateWords.KeyCount"
      >
        </el-table-column>
      <el-table-column 
        prop="DepartMentID"
        v-if="false"
        :label="translateWords.Country"
      >
      </el-table-column>
       <el-table-column 
        prop="StatusCode" 
        v-if="false"
        :label="translateWords.Status"
      >
      </el-table-column>

      <el-table-column :label="translateWords.operate"  >
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="primary" v-if="PermissonList.Update.value"
            @click="handleEdit(scope.$index, scope.row)"
            >{{ translateWords.edit }}</el-button
          >
          <el-button
            size="mini"
            type="primary" v-if="PermissonList.Delete.value"
            @click="handleDelete(scope.$index, scope.row)"
            >{{ translateWords.delete }}</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="1"
      :page-sizes="[10, 20, 30]"
      :page-size="10"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    >
    </el-pagination> 
         <el-dialog
      :visible.sync="dialogVisible"
      width="30%"
      :show-close="true"
          :close-on-click-modal="false"
    >
    <table>
      <tr>
        <td>
          <div style="float: left">
            <h1>{{ translateWords.title }}</h1>
          </div>
        </td>
      </tr>
      <tr>
        <td>
          <el-form
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
            label-width="200x"
            class="demo-ruleForm"
          >
            <table>
              <tr>
                <td>
                  <el-form-item
                    :label="translateWords.RegionName"
                    prop="RegionName"
                  >
                    <el-input v-model="ruleForm.RegionName"></el-input
                  ></el-form-item>
                </td>
              </tr>
              <tr>
                <td>
                  <el-form-item :label="translateWords.Status" prop="Status">
                    <el-select
                      v-model="ruleForm.Status"
                      :placeholder="translateWords.statusText"
                      filterable
                      style="width:300px"
                    >
                      <el-option
                        v-for="item in AddRegionStatusDropList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </td>
              </tr>
              <tr>
                <td>
                  <el-form-item
                    :label="translateWords.Country"
                    prop="DepartMentID"
                   
                  >
                    <el-select    style="width:300px"
                      v-model="ruleForm.DepartMentID"
                      :placeholder="translateWords.conuntryText"
                      filterable
                    >
                      <el-option
                        v-for="item in AddRegionCountryDropList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </td>
              </tr>
                 <tr>
                <td>
                  <el-form-item
                    :label="translateWords.IsUseKey"
                    prop="IsUseKey"
                
                  >
                    <el-select   style="width:300px"
                      v-model="ruleForm.IsUseKey"
                      :placeholder="translateWords.IsUseKey"
                     @change="changeisusekey"
                    >
                      <el-option 
                        v-for="item in IsUseKeyDropList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </td>
              </tr>
                   <tr v-if="showkeycount">
                <td>
                  <el-form-item
                    :label="translateWords.KeyCount"
                    prop="KeyCount"
                      :rules="[
      { required: true, message: '钥匙数量不能为空'},
      { type: 'number', message: '钥匙数量必须为数字值'}
    ]"
                  >
                    <el-input v-model.number="ruleForm.KeyCount"></el-input
                  ></el-form-item>
                </td>
              </tr>
            </table>
            <el-form-item style="float: left">
              <el-button type="primary" @click="submitForm('ruleForm')">{{
                translateWords.Save
              }}</el-button>
            </el-form-item>
          </el-form>
        </td>
      </tr>
    </table>
    </el-dialog> 
  </div>
</template>
<script>
import { importScript } from "../util/importScript";
import global from "./Global";
export default {
  name: "RegionNew",
  data() {
    return {
      uid: this.$route.query.uid,
      token: this.$route.query.token,
      lang: this.$route.query.lang,
      total: 0,
      currPage: 1,
      pageSize: 10,
      isQuery: false,
      isEdit:false,
      tableData: [],
      RegionQuery: {
        RegionName: "",
        Status: 0,
        DepartMentID: 0,
        IsUseKey:0,
        KeyCount:0
      },
      Id:0,
      IsUseKeyDropList:[],
      RegionStatusDropList: [],
      RegionCountryDropList: [],
      AddRegionStatusDropList: [],
      AddRegionCountryDropList: [],
      IsUseKeyDropList:[],
      dialogVisible:false,
      ruleForm: {
        RegionName: "",
        Status: 1, //启用
        DepartMentID: 0, //请选择
        IsUseKey:0,
        KeyCount:0
      },
       rules: {
        RegionName: [{ required: true, message: "区域不能为空" }],
      },
      showkeycount:false,
        // ModuleCode:'OAS.AreaManageMenu',
        //              PermissonList: {
        //                  Add: { key: 'OAS.AreaManageMenu.Add', value: false },
        //                  Delete: { key: 'OAS.AreaManageMenu.Delete', value: false },
        //                  Update: { key: 'OAS.AreaManageMenu.Update', value: false },
        //                  Search: { key: 'OAS.AreaManageMenu.Search', value: false }
        //              },
      translateWords:{
            
              AreaManage:"区域管理",
              RegionName:"区域名称",
              Country:"所属国家",
              Status:"状态",
              Code:"编码",
              query:"查询",
              operate:'操作',
              edit:'编辑',
              delete:'删除',
              successText:'保存成功',
              failText:'保存失败',
              statusText:'请选择状态',
              conuntryText:'请选择国家',
              regionText:'请选择区域',
              loadFail:'加载下拉区域失败',
              loadRegionFail:'加载区域失败',
              loadRoomFail:'加载房间区域列表失败',
              delSuccess:'删除成功',
              delfailt:'删除失败',
              selectOneRegion:'请选择一个区域',
              title:'新增区域',
              Edittitle:'编辑区域',
              Save:'保存',
              add:'新增区域',
              IsUseKey:'是否配置钥匙',
              KeyCount:'钥匙数量'
      }
    };
  },
  mounted() {
    var that = this;
    importScript(this.baseurl, () => {
      that.jsT = window.jsT;
      that.translateWord();
    });
  },
  created: function () {
  
     this.PermissonList=  global.methods.GetOaRight(this.$store.state.NewRegionModuleCode,this.$store.state.NewRegionPermissonList,this.$route.query.token,this.$http,this.oarighturl)
    this.setInitStatus();
    this.getData(1, 10);
    this.getisusekey();
  },
 
  methods: {
    translateWord() {
      let that = this;
      if (that.jsT) {
        //翻译词条，覆盖默认的
        this.translateWords = {
          RegionName: that.jsT.T(that.translateWords.RegionName), 
          AreaManage: that.jsT.T(that.translateWords.AreaManage),
          Country: that.jsT.T(that.translateWords.Country),
          Status: that.jsT.T(that.translateWords.Status),
          Code: that.jsT.T(that.translateWords.Code),
          query: that.jsT.T(that.translateWords.query),
          operate: that.jsT.T(that.translateWords.operate),
          edit: that.jsT.T(that.translateWords.edit),
          delete: that.jsT.T(that.translateWords.delete),
          //下面是方法中的词条
          successText: that.jsT.T(that.translateWords.successText),
          failText: that.jsT.T(that.translateWords.failText),
          statusText: that.jsT.T(that.translateWords.statusText),
          conuntryText:that.jsT.T(that.translateWords.conuntryText),
          regionText: that.jsT.T(that.translateWords.regionText),
          loadFail: that.jsT.T(that.translateWords.loadFail),
          loadRegionFail: that.jsT.T(that.translateWords.loadRegionFail),
          loadRoomFail: that.jsT.T(that.translateWords.loadRoomFail),
          delSuccess: that.jsT.T(that.translateWords.delSuccess),
          delfailt: that.jsT.T(that.translateWords.delfailt),
          selectOneRegion: that.jsT.T(that.translateWords.selectOneRegion),
          title:that.jsT.T(that.translateWords.title),
          Save:that.jsT.T(that.translateWords.Save),
          add:that.jsT.T(that.translateWords.add),
          Edittitle:that.jsT.T(that.translateWords.Edittitle),
            IsUseKey:that.jsT.T(that.translateWords.IsUseKey),
             KeyCount:that.jsT.T(that.translateWords.KeyCount),
        };
          this.rules = {
                    RegionName: [
                      { required: true, message: window.jsT.T('区域不能为空')}
                    ]
                  
              };        


      } else {
        console.log("翻译器没有加载成功");
      }
    },  
   
     changeisusekey(val)
  {
      if(val==0)
      {
         this.showkeycount=false;
         this.ruleForm.KeyCount=0;
      }
        if(val==1)
      this.showkeycount=true;
  },
    getisusekey()
    {
  var params = new URLSearchParams();
      params.append("cmd", "GetIsUseKey");
      params.append("lang", this.lang);
   
      this.$http.post(this.actionurl, params).then((res) => {
        this.IsUseKeyDropList = res.data.Data;
      
      });
    },
    getData(index, size) {
      var params = new URLSearchParams();
      params.append("pageIndex", index);
      params.append("pageSize", size);
      params.append("lang", this.lang);
         params.append("uid", this.uid);
      params.append("cmd", "LoadRegion");
      if (this.isQuery) {
        params.append("RegionName", this.RegionQuery.RegionName);
        params.append("Status", this.RegionQuery.Status);
        params.append("DepartMentID", this.RegionQuery.DepartMentID);
      }
      this.$http.post(this.actionurl, params).then((res) => {
        this.tableData = res.data.Data.list;
        this.total = res.data.Data.total;
      });
    },
    setInitStatus() {
      this.getcountry();
      this.getinitstatus();
    },
    getcountry() {
      var params = new URLSearchParams();
      params.append("cmd", "GetCountry");
      params.append("lang", this.lang);
         params.append("uid", this.uid);
      this.$http.post(this.actionurl, params).then((res) => {
        this.RegionCountryDropList = res.data.Data;
         this.AddRegionCountryDropList = res.data.Data;
      });
    },
    add()
    {     this.Id=0;
          this.isEdit=false;
          this.dialogVisible=true;
          this.ruleForm.RegionName='';
          this.ruleForm.Status=1;
          this.ruleForm.DepartMentID=0;
          this.ruleForm.IsUseKey=0;
          this.ruleForm.KeyCount=0;
          this.showkeycount=false;
          this.translateWords.title=this.jsT.T('新增区域');
    },
    getinitstatus() {
      var params = new URLSearchParams();
      params.append("cmd", "GetStatus");
      params.append("lang", this.lang);
      this.$http.post(this.actionurl, params).then((res) => {
        this.RegionStatusDropList = res.data.Data;
         this.AddRegionStatusDropList = res.data.Data;
         
      });
    },
      submitForm(formName) {
    
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.ruleForm.Status == 0) {
            alert(this.translateWords.statusText);
            return;
          }
          if (this.ruleForm.DepartMentID == 0) {
            alert(this.translateWords.conuntryText);
            return;
          }
          var params = new URLSearchParams();
          for (var key in this.ruleForm) {
            params.append(key, this.ruleForm[key]);
          }
            params.append("uid", this.uid);
            params.append("lang", this.lang);
              if((this.ruleForm.IsUseKey==1)&&(this.ruleForm.KeyCount<1))
            {
                alert("请输入大于0的数字")
                return;
            }
            if(this.isEdit)
            {
                   params.append("Id", this.Id);
                   params.append("cmd", "EditRegion");
            }
            else
            { 
                this.translateWords.title=this.jsT.T("新增区域"),
                params.append("cmd", "SaveRegion");
            }
            this.$http.post(this.actionurl, params)
              .then(res => {
                if (res.data.Message == "") {  
                alert(this.translateWords.successText);
                }
                else {
                    alert(this.translateWords.failText+","+res.data.Message);
                }
                this.dialogVisible=false;
                this.getData(1,10);
              })

        }
         else {
          return false;
        }
      });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.currPage = 1;
      this.getData(this.currPage, this.pageSize);
    },
    handleCurrentChange(val) {
      this.currPage = val;
      this.getData(this.currPage, this.pageSize);
    },
    query() {
      this.isQuery = true;
      this.getData(1, 10);
    },
    handleEdit(index, row) {
        
        this.dialogVisible=true
        this.isEdit=true;
        this.Id=row.Id;
       this.translateWords.title=this.jsT.T('编辑区域');
        this.ruleForm.Status=row.StatusCode;
        this.ruleForm.DepartMentID=row.DepartMentID==null?0:row.DepartMentID;
        this.ruleForm.RegionName=row.RegionName;
        this.ruleForm.IsUseKey=row.IsUseKey;
        this.ruleForm.KeyCount=row.KeyCount;
        if(row.IsUseKey==1)
        {
          this.showkeycount=true;
        }
           if(row.IsUseKey==0)
        {
          this.showkeycount=false;
         
        }
    },
    handleDelete(index, row) {
      var that = this;
      var params = new URLSearchParams();
      params.append("id", row.Id);
      params.append("uid", this.uid);
      params.append("lang", this.lang);
      params.append("cmd", "DeleteRegion");
      this.$http.post(this.actionurl, params).then((res) => {
        if (res.data.Message == "") {
          alert(that.translateWords.delSuccess);
          this.getData(1, 10);
        } else {
          alert(res.data.Message);
        }
      });
    },
  },
};
</script>




// WEBPACK FOOTER //
// src/components/RegionNew.vue